import { LoquixDisagreementMarker } from './loquix-disagreement-marker.js';

if (!customElements.get('loquix-disagreement-marker')) {
  customElements.define('loquix-disagreement-marker', LoquixDisagreementMarker);
}
